import { Title_20_Coral_Strong_emphasis_20 } from "@UI/typography/generated/typography"
import { Stack } from "@src/CommonComponents/Stack/Stack"
import {Button, ButtonType} from "@UI/components/controls/Button/Button.tsx";
import {clearLocalDatabase} from "@src/db.ts";
import {Gt} from "@src/i18n/Gt.tsx";

export const ClearLocalDbModal = ({close}: {close: () => void}) => {
    return (
        <Stack direction={"column"} style={{padding: "16px"}}>
            <Title_20_Coral_Strong_emphasis_20>
                <Gt>Clear local database?</Gt>
            </Title_20_Coral_Strong_emphasis_20>
            <Stack>
                <Button type={ButtonType.primary} onClick={close}
                        style={{width: "25px"}}><Gt>No</Gt></Button>
                <Button type={ButtonType.third} onClick={() => {
                    clearLocalDatabase()
                    close()
                }}
                        style={{width: "25px"}}><Gt>Yes</Gt></Button>
            </Stack>

        </Stack>
    )
}